import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from '../context/LanguageContext';
import './NotFound.css';

export default function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="nf-page">
      <div className="nf-bg-glow nf-glow-1" />
      <div className="nf-bg-glow nf-glow-2" />
      <div className="nf-grid" />

      <div className="nf-content">
        <div className="nf-code">404</div>
        <div className="nf-divider" />
        <h1 className="nf-title">{t('agency.notfound_title', 'Page Not Found')}</h1>
        <p className="nf-desc">
          {t('agency.notfound_moved_desc', 'The page you are looking for does not exist or has been moved.')}<br />
          {t('agency.notfound_back_on_track_desc', 'Let us get you back on track.')}
        </p>
        <div className="nf-actions">
          <button className="nf-btn-primary" onClick={() => navigate(-1)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
            {t('agency.notfound_go_back_btn', 'Go Back')}
          </button>
          <Link to="/" className="nf-btn-outline">{t('agency.notfound_back_home_btn', 'Back to Home')}</Link>
        </div>
        <div className="nf-links">
          <span className="nf-links-label">{t('agency.notfound_quick_links_label', 'Quick links:')}</span>
          {[
            { label: 'Training', labelKey: 'agency.notfound_training_label', path: '/training' },
            { label: 'IT Services', labelKey: 'agency.notfound_it_services_label', path: '/it-services' },
            { label: 'Enterprise AI', labelKey: 'agency.notfound_enterprise_ai_label', path: '/enterprise-ai' },
            { label: 'Contact', labelKey: 'agency.notfound_contact_label', path: '/contact' },
          ].map(l => (
            <Link key={l.path} to={l.path} className="nf-quick-link">{t(l.labelKey, l.label)}</Link>
          ))}
        </div>
      </div>
    </div>
  );
}
